module.exports = __webpack_public_path__ + "static/media/logo_lishi.4540211e.png";